/*
  WGAF size choice (26 Oct 2026)
  Shoppers must choose a size before they can add to cart or use express pay.
  - Size starts unselected (colour stays preselected).
  - Add to cart reads "Choose your size"; tapping it scrolls to and highlights the size row.
  - Express pay buttons are hidden until a size is chosen.
  - A "Size guide" link sits beside the Size label and jumps to the size table in the description.
  - A chosen size is remembered for the session, so it carries across the Full Voice / Room Voice switch.
  Loaded once from snippets/selected-pick.liquid, outside <variant-selects>,
  and re-applied after Dawn re-renders the picker on each option change.
*/
(function () {
  if (window.__wgafSizeChoice) return;
  window.__wgafSizeChoice = true;

  var KEY = 'wgaf-size';
  var CTA = 'Choose your size';
  var chosen = false;
  var applying = false;

  function getStored() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function setStored(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }

  function sizeInputs() {
    return document.querySelectorAll('variant-selects input[type="radio"][data-option-name="Size"]');
  }
  function sizeFieldset() {
    var first = sizeInputs()[0];
    return first ? first.closest('fieldset') : null;
  }
  function needsChoice() { return !chosen && sizeInputs().length > 0; }
  function nameFor(n) { return /^colou?r$/i.test(n) ? 'Colour' : n; }

  function updatePick() {
    var out = document.querySelector('[data-wgaf-pick-value]');
    if (!out) return;
    var parts = [];
    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown').forEach(function (fs) {
      var legend = fs.querySelector('legend, label.form__label');
      var name = legend ? legend.childNodes[0].textContent.replace(':', '').trim() : '';
      var checked = fs.querySelector('input[type="radio"]:checked');
      var select = fs.querySelector('select');
      var val = checked ? checked.value : (select ? select.value : '');
      if (name) parts.push(nameFor(name) + ': ' + (val || 'choose yours'));
    });
    var text = parts.join(' · ');
    if (text && out.textContent !== text) out.textContent = text;
  }

  function findSizeTable() {
    var tables = document.querySelectorAll('.product__description table, .product__info-container table, main table');
    for (var i = 0; i < tables.length; i++) {
      if (/width/i.test(tables[i].innerText) && /length/i.test(tables[i].innerText)) return tables[i];
    }
    return null;
  }

  function flash(el) {
    if (!el) return;
    el.classList.remove('wgaf-flash');
    void el.offsetWidth;
    el.classList.add('wgaf-flash');
    setTimeout(function () { el.classList.remove('wgaf-flash'); }, 1600);
  }

  function addGuideLink(fs) {
    if (!fs) return;
    var legend = fs.querySelector('legend');
    if (!legend || legend.querySelector('.wgaf-size-guide-link')) return;
    var table = findSizeTable();
    if (!table) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wgaf-size-guide-link';
    btn.textContent = 'Size guide';
    btn.addEventListener('click', function () {
      var t = findSizeTable();
      if (!t) return;
      var details = t.closest('details');
      if (details) details.open = true;
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      flash(t);
    });
    legend.appendChild(document.createTextNode(' '));
    legend.appendChild(btn);
  }

  function lock() {
    document.querySelectorAll('product-form').forEach(function (pf) { pf.classList.add('wgaf-needs-size'); });
    document.querySelectorAll('product-form .product-form__submit').forEach(function (b) {
      if (b.disabled) return; // sold out / unavailable keeps Dawn's own state
      var span = b.querySelector('span');
      if (span && span.textContent.trim() !== CTA) {
        b.dataset.wgafLabel = span.textContent.trim();
        span.textContent = CTA;
      }
      b.setAttribute('aria-disabled', 'true');
    });
  }

  function unlock() {
    document.querySelectorAll('product-form').forEach(function (pf) { pf.classList.remove('wgaf-needs-size'); });
    document.querySelectorAll('product-form .product-form__submit').forEach(function (b) {
      var span = b.querySelector('span');
      if (span && span.textContent.trim() === CTA) span.textContent = b.dataset.wgafLabel || 'Add to cart';
      b.removeAttribute('aria-disabled');
    });
  }

  function apply() {
    if (applying) return;
    applying = true;
    try {
      var inputs = sizeInputs();
      if (!inputs.length) return;
      var fs = sizeFieldset();
      addGuideLink(fs);
      if (chosen) { unlock(); updatePick(); return; }
      inputs.forEach(function (i) { i.checked = false; });
      var sel = fs && fs.querySelector('[data-selected-value]');
      if (sel && sel.textContent !== '') sel.textContent = '';
      lock();
      updatePick();
    } finally {
      applying = false;
    }
  }

  function nudge() {
    var fs = sizeFieldset();
    if (!fs) return;
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    flash(fs);
  }

  // A size tapped by the shopper is a real choice. Runs before Dawn re-renders.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('variant-selects input[type="radio"][data-option-name="Size"]')) {
      chosen = true;
      setStored(t.value);
      unlock();
    }
  }, true);

  // Block add to cart (click or Enter) until a size is chosen.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('product-form .product-form__submit');
    if (!b || !needsChoice()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest || !f.closest('product-form') || !needsChoice()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge();
  }, true);

  function init() {
    var inputs = sizeInputs();
    if (!inputs.length) return;
    var checked = document.querySelector('variant-selects input[type="radio"][data-option-name="Size"]:checked');
    var stored = getStored();
    // Carry a size the shopper already chose this session (e.g. across the voice switch).
    chosen = !!(stored && checked && checked.value === stored);
    apply();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(apply, 0); });
    }
    // Fallback: re-apply after any re-render of the picker or buy buttons.
    var timer;
    var target = document.querySelector('product-info') || document.querySelector('main');
    if (target && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (applying) return;
        clearTimeout(timer);
        timer = setTimeout(apply, 50);
      }).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
